export default {"src":"/_next/static/media/promo.503561c6.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};